import React from 'react';
interface NoticeListItemProps {
  date: string;
  title: string;
  desc: string;
  isNew?: boolean;
}
export function NoticeListItem({
  date,
  title,
  desc,
  isNew
}: NoticeListItemProps) {
  return <div className="bg-white p-6 border border-club-border rounded-sm hover:shadow-sm transition-shadow" data-id="element-265">
      <div className="flex items-center gap-3 mb-2" data-id="element-266">
        <span className="text-sm text-club-gold font-medium" data-id="element-267">{date}</span>
        {isNew && <span className="bg-club-green text-white text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-sm font-semibold" data-id="element-268">
            New
          </span>}
      </div>
      <h4 className="text-xl mb-2 text-club-green" data-id="element-269">{title}</h4>
      <p className="text-club-ink/70 text-sm leading-relaxed" data-id="element-270">{desc}</p>
    </div>;
}